export function groupBy(arr, fn) {
    return arr.reduce(function (obj, item) {
        const key = typeof fn === "function" ? fn(item) : item[fn];
        if (!obj.hasOwnProperty(key)) {
            obj[key] = [];
        }
        obj[key].push(item);
        return obj;
    }, {});
}
export const percentageDiff = (startingValue, finalValue) => {
    const percentageDifference = ((finalValue - startingValue) / startingValue) * 100;
    return Math.round(percentageDifference * 100) / 100;
};
export function tryParseJson(input) {
    try {
        return JSON.parse(input);
    }
    catch (e) {
        return undefined;
    }
}
